// Module
var code = "<div class=\"im-chat-float\"> <div class=\"chat-float-btns\"> <div class=\"chat-float-btn\"> <div class=\"chat-float-add\"></div> <span>添加新成员</span> </div> </div> <div class=\"chat-float-members\"></div> </div> ";
// Exports
module.exports = code;